module.exports = __webpack_public_path__ + "images/79647781a6525dc117bacde6dffe90f5.png";